import React from "react";
import { Image } from "react-bootstrap";

interface SideButtonProps {
    opportunityId: number | null;
}

const SideButton: React.FC<SideButtonProps> = ({ opportunityId }) => {
    return (
        <>
            <div className="right-sidebar-icon-wrapper left-sidebar-icon-wrapper">
                <a href={`contact?opportunity_id=${opportunityId}`}>
                    <Image className="img img-fluid" src="assets/images/other/icon-sidebar-comment-bg-red.svg" />
                </a>
            </div>
            <a href={`contact_list?opportunity_id=${opportunityId}`}
                className="right-sidebar-icon-wrapper left-sidebar-icon-wrapper left-sidebar-icon-wrapper-2"
            >
                <Image className="img img-fluid" src="assets/images/other/icon-sidebar-comments-bg-blue.svg" />
            </a>
        </>
    )
}

export default SideButton;